import {useNavigate} from 'react-router-dom'

export const HasErrorInShowPage = ({text}: {text?: string}) => {
  const navigate = useNavigate()

  const handle = () => {
    navigate(-1)
  }

  return (
    <div className='container'>
      <div className='text-center mt-5'>
        <h2>Oopss...</h2>
        <p>{text || 'Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.'}</p>
        <button className='btn btn-danger' onClick={handle}>
          Voltar
        </button>
      </div>
    </div>
  )
}
